export enum ActiveStatusEnum {
  Active = 1,
  Hold = 2,
  Phaseout = 3,
  Inactive = 4,
}

export enum DocSubmitTypeEnum {
  Print = 0,
  Email = 1,
  PrintAndEmail = 2,
  None = 3,
}

export enum AddonBinStatusEnum {
  New = 0,
  Open = 1,
  InProcess = 2,
  OnHold = 3,
  Closed = 4,
}

export enum AddonBinStationStatusEnum {
  Await = 1,
  InProcess = 2,
  OnHold = 3,
  Closed = 4,
  Pending = 5,
}

export enum BarcodePrintStatusEnum {
  NotYetPrinted = 0,
  PrintedForStock = 1,
  PrintedForJobOrder = 2,
}

export enum CancellationReasonTypeEnum {
  NoLongerNeeded = 0,
  OrderedInError = 1,
  Other = 2,
  ManufacturerDiscontinued = 3,
  ManufacturerConfirmedUnable = 4,
  MigrationCleanup = 5,
}

export enum CancellationRequestStatusEnum {
  InProcess = 0,
  Closed = 1,
}

export enum CancellationRequestDetailStatusEnum {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
}

export enum CreditMemoStatusEnum {
  Unposted = 0,
  Posted = 1,
  AwaitPost = 2,
}

export enum CreditMemoTypeEnum {
  Memo = 0,
  PrepaymentRefund = 1,
  PcardRefund = 2,
}

export enum CreditMemoLedgerEntryKindEnum {
  ProductCredit = 0,
  RestockingCharge = 1,
}

export enum EntityEventTypeEnum {
  JoDetailExpectedShipDateChange = 1,
  JoHeaderShipped = 2,
  ShipmentCreated = 3,
}

export enum WarningTypeEnum {
  Warning = 0,
  Error = 1,
  CriticalError = 2,
}

export enum ItemDetailStatusEnum {
  InInventory = 0,
  InProcessPendingShipPrep = 10,
  InProcessPendingAddon = 11,
  InProcessAddon = 20,
  InProcessShipPrep = 30,
  InProcessShipHeld = 31,
  InProcessVoucher = 45,
  Shipped = 50,
  Special = 60,
  MigratedUnknown = 91,
  MissingFromInventory = 93,
  DamagedOrOther = 99,
}

export enum ManufacturerFeedStatusEnum {
  None = 1,
  Available = 3,
}

export enum NotificationEventEnum {
  JobOrderShipped = 10,
  JobOrderDelayed = 11,
  InvoiceEmail = 20,
  ManifestEmail = 30,
  PurchaseOrderEmail = 40,
  PoCancelRequest = 41,
  EmailHeader = 100,
  EmailFooter = 101,
  FreeForm = 1000,
}

export enum NotificationQueryEnum {
  UnitecAddress = 1,
  Invoice = 2,
  Manifest = 3,
  PurchaseOrder = 4,
  JobOrder = 10,
}

export enum NotificationTypeEnum {
  Email = 0,
  SMS = 1,
  InApp = 2,
}

export enum ProxReceiptStatusEnum {
  Received = 1,
  Processed = 2,
  Failed = 3,
}

export enum ProxSubmissionStatusEnum {
  NotYetSent = 0,
  InProcess = 1,
  Complete = 2,
  Error = -2,
  TimeoutError = -1,
}

export enum ReturnReasonTypeEnum {
  Return = 0,
  Repair = 1,
}

export enum ReturnRequestStatusEnum {
  InProcess = 0,
  Closed = 1,
}

export enum ReturnRequestDetailStatusEnum {
  AwaitingReceipt = 0,
  ReceivedInquiryPending = 1,
  ReceivedRepairPending = 2,
  ReturnedToCustomerRepaired = 3,
  ReturnedToCustomerRejected = 4,
  ReceivedCreditApplied = 5,
  ReceivedAsAccountOwned = 6,
}

export enum ShipmentStatusEnum {
  New = 0,
  Shipped = 1,
  Received = 2,
  Other = 3,
}

